<script>
  import { colors } from './utils.js';
	import { getContext } from 'svelte';

	export let theme = getContext('theme');
</script>

<nav style="border-bottom: 1px solid {colors[theme]['muted']};">
  <div class="col-wide middle">
		<a href="https://ons.gov.uk/">
			<picture>
				{#if theme == 'dark'}
				<source media="(max-width: 499px)" srcset="https://ons-design-system.netlify.app/img/ons-logo-stacked-neg-en.svg" alt="Office for National Statistics">
				<img src="https://ons-design-system.netlify.app/img/ons-logo-neg-en.svg" alt="Office for National Statistics">
				{:else}
				<source media="(max-width: 499px)" srcset="https://ons-design-system.netlify.app/img/ons-logo-stacked-black-en.svg" alt="Office for National Statistics">
				<img src="https://ons-design-system.netlify.app/img/ons-logo-black-en.svg" alt="Office for National Statistics">
				{/if}
			</picture>
		</a>
  </div>
</nav>

<style>
	nav {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		position: relative;
		height: 46px;
		margin-bottom: -46px;
	}
	picture {
		position: relative;
		top: -3px;
	}
</style>